import Vue from 'vue'
import { AppConst } from '@/constants'
import { CategoryState, DeleteCategoryResponse, LibraryCategories, LibraryCategoriesUsageResponse, LibraryCategory, LibraryCategoryStates, LibraryCategoryUsage, LibraryEntry, LibraryReferenceAsset, LibraryReferenceAssetsResponse } from '@/store/modules/teamlibrary/types'
import { ListHelpers } from '@/utils/list-helpers'

export default {
  updateModelsLibrary(state: any, response: any) {
    // state.itemsPerPage = response.limit
    state.currentPage = response.page
    state.totalPages = response.total_pages
    state.totalRows = response.total_rows

    state.modelsLibrary = response.rows
    state.modelsLibraryTags = [...new Set(response.rows.flatMap((m: LibraryEntry) => m.Tags))]

    this.updateHelpHeroData(AppConst.HelpHero.helpHeroModelsCountKey, response.rows.length)
  },
  updateLibListCurrentPage(state: any, currentPage: number) {
    state.currentPage = currentPage
  },
  updateLibraryItemsPerPage(state: any, itemsPerPage: number) {
    state.itemsPerPage = itemsPerPage
  },
  updateLibraryTotalPages(state: any, totalPages: number) {
    state.totalPages = totalPages
  },
  updateLibraryTotalRows(state: any, totalRows: number) {
    state.totalRows = totalRows
  },
  updateLibraryPublicCategories(state: any, responseLibPublicCategories: LibraryCategories) {
    state.libraryPublicCategories = responseLibPublicCategories
  },
  addLibraryPublicCategory(state: any, category: LibraryCategory) {
    if (state.libraryPublicCategories == null) {
      state.libraryPublicCategories = {
        Categories: [],
        CategoryOrder: [],
      }
    }

    state.libraryPublicCategories.Categories.push(category)
  },
  updateLibraryPublicCategory(state: any, payload: { index: number; updates: Partial<LibraryCategory> }) {
    if (state.libraryPublicCategories == null || state.libraryPublicCategories.Categories == null) {
      return
    }

    const { index, updates } = payload
    if (index < 0 || index >= state.libraryPublicCategories.Categories.length) {
      return
    }

    const existing = state.libraryPublicCategories.Categories[index]
    Vue.set(state.libraryPublicCategories.Categories, index, {
      ...existing,
      ...updates,
    })
  },
  replaceLibraryPublicCategories(state: any, categories: LibraryCategory[]) {
    if (state.libraryPublicCategories == null) {
      state.libraryPublicCategories = {
        Categories: [],
        CategoryOrder: [],
      }
    }

    state.libraryPublicCategories.Categories = categories
  },
  refreshLibraryPublicCategories(state: any) {
    if (state.libraryPublicCategories == null || state.libraryPublicCategories.Categories == null) {
      return
    }

    state.libraryPublicCategories.Categories = state.libraryPublicCategories.Categories.slice()
  },
  setLibraryPublicCategoryOrder(state: any, order: number[] | null) {
    if (state.libraryPublicCategories == null) {
      state.libraryPublicCategories = {
        Categories: [],
        CategoryOrder: order || [],
      }
      return
    }

    state.libraryPublicCategories.CategoryOrder = order
  },
  updateLibraryCategories(state: any, responseLibCategories: LibraryCategories) {
    state.libraryCategories = responseLibCategories
  },
  replaceLibraryCategories(state: any, categories: LibraryCategory[]) {
    if (state.libraryCategories == null) {
      state.libraryCategories = {
        Categories: [],
        CategoryOrder: [],
      }
    }

    state.libraryCategories.Categories = categories
  },
  setLibraryCategoryOrder(state: any, order: number[] | null) {
    if (state.libraryCategories == null) {
      state.libraryCategories = {
        Categories: [],
        CategoryOrder: order || [],
      }
      return
    }

    state.libraryCategories.CategoryOrder = order
  },
  updateLibraryCategoriesUsage(state: any, responseLibCategoriesUsage: LibraryCategoriesUsageResponse) {
    responseLibCategoriesUsage.usage.forEach((usage: LibraryCategoryUsage) => {
      Vue.set(state.libraryCategoriesUsage.usageMap, usage.category_id, usage.count)
    })
    state.libraryCategoriesUsage.usage = responseLibCategoriesUsage.usage
  },
  updateLibraryCategoryStates(state: any, responseStates: LibraryCategoryStates) {
    state.libraryCategoryStates = responseStates
    if (state.libraryCategoryStates.States.length) {
      const activeState: CategoryState | null = state.libraryCategoryStates.States.find((state: CategoryState) => state.StateName.toLowerCase() === 'active')

      if (activeState) {
        state.defaultLibraryCategoryState = activeState
      }
    }
  },
  deleteLibraryCategoryById(state: any, deleteCategoryResponse: DeleteCategoryResponse) {
    ListHelpers.deleteById(state.libraryCategories.Categories, 'CategoryId', deleteCategoryResponse.categoryId)

    const filteredOrder = state.libraryCategories.CategoryOrder.filter((categoryId: number) => categoryId !== deleteCategoryResponse.categoryId)
    state.libraryCategories.CategoryOrder = filteredOrder
  },
  updateLibraryEntry(state: any, entry: LibraryEntry) {
    state.libraryEntry = entry
  },
  updateLibraryReferenceAssets(state: any, assets: LibraryReferenceAssetsResponse) {
    state.libraryReferenceAssets = assets.references
  },
  removeLibraryReferenceAssetByGuid(state: any, assetGuid: string) {
    const index = state.libraryReferenceAssets.findIndex((asset: LibraryReferenceAsset) => asset.assetGuid === assetGuid)
    if (index >= 0) {
      state.libraryReferenceAssets.splice(index, 1)
    }
  },
  deleteFromModelsLibraryById(state: any, id: string) {
    ListHelpers.deleteById(state.modelsLibrary, 'Id', id)
  },
  resetLibraryData(state: any) {
    state.modelsLibrary = []
    state.libraryEntry = {
      DisplayName: '',
      Tags: [],
      Categories: [],
      Item: {
        Id: -1,
        URL_Reference: '',
      },
    }
  },
}
